import { useEffect, useState } from 'react';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import CopyToClipboard from '../copyToClipboard';
import AdminCollapseFile from './AdminCollapseFile';

const AdminCollapse = ({ tempWorker, tempWorkerToEdit, isWaiting }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [nbFiles, setNbFiles] = useState(0);
  const [nbFilesTotal, setNbFilesTotal] = useState(0);

  const [isCNIFiles, setIsCNIFiles] = useState(false);
  const [isPassportFiles, setIsPassportFiles] = useState(false);
  const [isSelfieFiles, setIsSelfieFiles] = useState(false);
  const [isVisaFiles, setIsVisaFiles] = useState(false);
  const [isVitalCardFiles, setIsVitalCardFiles] = useState(false);
  const [isProofOfAddressFiles, setIsProofOfAddressFiles] = useState(false);
  const [isAccommodationFiles, setIsAccommodationFiles] = useState(false);

  const [statusCNIFiles, setStatusCNIFiles] = useState(1);
  const [statusPassportFiles, setStatusPassportFiles] = useState(1);
  const [statusSelfieFiles, setStatusSelfieFiles] = useState(1);
  const [statusVisaFiles, setStatusVisaFiles] = useState(1);
  const [statusVitalCardFiles, setStatusVitalCardFiles] = useState(1);
  const [statusProofOfAddressFiles, setStatusProofOfAddressFiles] = useState(1);
  const [statusAccommodationFiles, setStatusAccommodationFiles] = useState(1);

  const [hideThisCollapse, setHideThisCollapse] = useState(false);
  const [tempWorkerResult, setTempWorkerResult] = useState(tempWorker);
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (isOpen) {
      // rien à faire pour l’instant
    }
  }, [isOpen]);

  const hasValidation = (v) => {
    if (v === undefined || v === null) return false;
    const num = Number(v);
    return !isNaN(num) && num >= 1;
  };

  // Helper : statut accepté comptabilisé dans nbFiles
  const isAccepted = (v) => {
    const n = parseInt(v);
    return n === 2 || n === 3;
  };

  useEffect(() => {
    let total = 0;
    let accepted = 0;

    // Identity (CNI / Passport)
    const idValidated = tempWorkerResult?.identity?.validated;
    if (hasValidation(idValidated)) {
      const idType = tempWorkerResult?.identity?.type;
      const status = parseInt(idValidated);

      if (idType === 'CNI') {
        setIsCNIFiles(true);
        setStatusCNIFiles(status);
      } else {
        setIsPassportFiles(true);
        setStatusPassportFiles(status);
      }
      if (isAccepted(status)) accepted++;
      total++;
    }

    // Selfie
    const selfieValidated = tempWorkerResult?.selfie?.validated;
    if (hasValidation(selfieValidated)) {
      setIsSelfieFiles(true);
      const status = parseInt(selfieValidated);
      setStatusSelfieFiles(status);
      if (isAccepted(status)) accepted++;
      total++;
    }

    // Visa
    const visaValidated = tempWorkerResult?.visa?.validated;
    if (hasValidation(visaValidated)) {
      setIsVisaFiles(true);
      const status = parseInt(visaValidated);
      setStatusVisaFiles(status);
      if (isAccepted(status)) accepted++;
      total++;
    }

    // Carte vitale
    const vitaleValidated = tempWorkerResult?.card_vitality?.validated;
    if (hasValidation(vitaleValidated)) {
      setIsVitalCardFiles(true);
      const status = parseInt(vitaleValidated);
      setStatusVitalCardFiles(status);
      if (isAccepted(status)) accepted++;
      total++;
    }

    // Justificatif de domicile
    const poaValidated = tempWorkerResult?.proof_of_address?.validated;
    if (hasValidation(poaValidated)) {
      setIsProofOfAddressFiles(true);
      const status = parseInt(poaValidated);
      setStatusProofOfAddressFiles(status);
      if (isAccepted(status)) accepted++;
      total++;
    }

    // Attestation d'hébergement
    const accValidated = tempWorkerResult?.accommodation_of_address?.validated;
    if (hasValidation(accValidated)) {
      setIsAccommodationFiles(true);
      const status = parseInt(accValidated);
      setStatusAccommodationFiles(status);
      if (isAccepted(status)) accepted++;
      total++;
    }

    setNbFiles(accepted);
    setNbFilesTotal(total);
  }, [tempWorkerResult]);

  useEffect(() => {
    if (tempWorkerToEdit.length > 0) {
      if (tempWorkerResult._id === tempWorkerToEdit[0]._id) {
        setTempWorkerResult(tempWorkerToEdit[0]);
        if (tempWorkerToEdit[0].isTempWorkerValidate) {
          setTimeout(() => setHideThisCollapse(true), 400);
        }
      }
    }
  }, [tempWorkerToEdit]);

  return (
    <>
      {isWaiting ? (
        <div className="flex shadow border rounded-md animate-fadeIn animate-pulse">
          <div className="items-center w-full my-2">
            <h3
              className={`${
                width > 768 ? 'flex justify-between flex-1' : ''
              } grep-3 p-4 font-semibold`}
            >
              <div className="h-3 bg-gray-200 rounded w-1/4 mx-3"></div>
              <div className="h-3 bg-gray-200 rounded w-1/4 mx-3"></div>
              <div className="h-3 bg-gray-200 rounded w-1/4 mx-3"></div>
              <div className="h-3 bg-gray-200 rounded w-1/4 mx-3"></div>
            </h3>
          </div>
        </div>
      ) : (
        !hideThisCollapse && (
          <details
            className={`bg-white shadow rounded group animate-fadeIn ${
              width > 768 ? '' : 'inline-block w-6/12'
            } ${
              tempWorkerToEdit.length > 0
                ? tempWorkerResult._id === tempWorkerToEdit[0]._id &&
                  tempWorkerToEdit[0].isTempWorkerValidate
                  ? 'animate-slideFadeOutL'
                  : ''
                : ''
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <summary
              className={`list-none ${
                width > 768 ? 'flex flex-wrap' : ''
              } items-center cursor-pointer focus-visible:outline-none focus-visible:ring focus-visible:ring-pink-500 rounded group-open:rounded-b-none group-open:z-[1] relative`}
            >
              <h3
                className={`${
                  width > 768 ? 'flex justify-between flex-1' : ''
                } grep-3 p-4 font-semibold`}
              >
                <div>
                  {tempWorkerResult.user.firstname +
                    ' ' +
                    tempWorkerResult.user.lastname}
                </div>
                <div>
                  <CopyToClipboard text={tempWorkerResult.user.email}>
                    <a
                      className="underline"
                      href={`mailto:${tempWorkerResult.user.email}`}
                    >
                      {tempWorkerResult.user.email}
                    </a>
                  </CopyToClipboard>
                </div>
                <div>
                  <CopyToClipboard text={tempWorkerResult.user.phone}>
                    <a
                      className="underline"
                      href={`tel:${tempWorkerResult.user.phone}`}
                    >
                      {tempWorkerResult.user.phone}
                    </a>
                  </CopyToClipboard>
                </div>
                <div>{nbFiles + '/' + nbFilesTotal}</div>
              </h3>
              <div className="flex w-10 items-center justify-center">
                <div className="border-8 border-white border-l-gray-600 ml-2 group-open:rotate-90 transition-transform origin-left"></div>
              </div>
            </summary>

            <div className="p-4">
              {isCNIFiles && (
                <AdminCollapseFile
                  title={"Carte d'identité"}
                  dateAdd={tempWorkerResult.identity.updated}
                  status={
                    statusCNIFiles === 1
                      ? 4
                      : statusCNIFiles === 2
                      ? 5
                      : statusCNIFiles
                  }
                  type="identity"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}

              {isPassportFiles && (
                <AdminCollapseFile
                  title={'Passeport'}
                  dateAdd={tempWorkerResult.identity.updated}
                  status={
                    statusPassportFiles === 1
                      ? 4
                      : statusPassportFiles === 2
                      ? 5
                      : statusPassportFiles
                  }
                  type="identity"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}

              {isSelfieFiles && (
                <AdminCollapseFile
                  title={'Selfie'}
                  dateAdd={tempWorkerResult.selfie.updated}
                  status={
                    statusSelfieFiles === 1
                      ? 4
                      : statusSelfieFiles === 2
                      ? 5
                      : statusSelfieFiles
                  }
                  type="selfie"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}

              {isVisaFiles && (
                <AdminCollapseFile
                  title={'Visa'}
                  dateAdd={tempWorkerResult.visa.updated}
                  status={
                    statusVisaFiles === 1
                      ? 4
                      : statusVisaFiles === 2
                      ? 5
                      : statusVisaFiles
                  }
                  type="visa"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}

              {isVitalCardFiles && (
                <AdminCollapseFile
                  title={'Carte vitale'}
                  dateAdd={tempWorkerResult.card_vitality.updated}
                  status={
                    statusVitalCardFiles === 1
                      ? 4
                      : statusVitalCardFiles === 2
                      ? 5
                      : statusVitalCardFiles
                  }
                  type="card_vitality"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}

              {isProofOfAddressFiles && (
                <AdminCollapseFile
                  title={'Justificatif de domicile'}
                  dateAdd={tempWorkerResult.proof_of_address.updated}
                  status={
                    statusProofOfAddressFiles === 1
                      ? 4
                      : statusProofOfAddressFiles === 2
                      ? 5
                      : statusProofOfAddressFiles
                  }
                  type="proof_of_address"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}

              {isAccommodationFiles && (
                <AdminCollapseFile
                  title={"Attestation d'hébergement"}
                  dateAdd={tempWorkerResult.accommodation_of_address.updated}
                  status={
                    statusAccommodationFiles === 1
                      ? 4
                      : statusAccommodationFiles === 2
                      ? 5
                      : statusAccommodationFiles
                  }
                  type="accommodation_of_address"
                  _id={tempWorkerResult._id}
                  id_user={tempWorkerResult.id_user}
                />
              )}
            </div>
          </details>
        )
      )}
    </>
  );
};

export default AdminCollapse;
